import React from "react";

import {Container} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {openInNewTab} from "../../utils/utils";
import PtfBuilderLogo from "./images/pb-logo.png";
import PtfBuilderContactsImg from "./images/pb-contacts.png";
import PtfBuilderOnboardingImg from './images/onboarding.png';
import PtfBuilderTradingImg from './images/trading.png';
import PtfBuilderMPImg from './images/mp.png';
import {PrimaryButton} from "../../components/Buttons";
import PbButton from "./components/PbButton";
import MusterDepotSelectionModal from "./components/MusterdepotSelectionModal";
import CustomerDepotSelectionModal from "./components/CustomerDepotSelectionModal/index";
import PageLoadingIndicator from "../RiskProfiling/components/PageLoadingIndicator";
import CustomerSelectionForOnboarding from "./components/CustomerSelectionForOnboarding";

import styles from "./styles";

const ArrowIcon = <FontAwesomeIcon icon={['fal', 'long-arrow-right']} />;

const PortfolioBuilderPage = ({classes}) => {

  const [loading, setLoading] = React.useState(false);

  if(loading) {
    return <PageLoadingIndicator />
  }

  return (
    <Container style={{paddingBottom: 24}}>
      <div className={classes.blueContainer}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid container spacing={2} justify={"space-between"} style={{marginBottom: 32}}>
              <Grid item xs className={classes.title}>
                Individuelle Anlageberatung auf institutionellem Niveau
              </Grid>
              <Grid item xs={'auto'}>
                <img src={PtfBuilderLogo} alt="Pb Logo" className={classes.logo}/>
              </Grid>
              <Grid item xs={12} style={{fontSize: 16}} container spacing={2}>
                <Grid item xs={12}>
                  So starten Sie den DIVA Portfolio Builder: In der Anlageberatung können Sie ein neues Depot anlegen
                  oder ein bestehendes ändern. Sie können außerdem mit einem Musterdepot in das System abspringen.
                </Grid>
                <Grid item xs={12}>
                  Der Portfolio Builder arbeitet am besten ab 5.000 Euro Anlagevolumen; angeschlossene Depotbanken sind:
                  FFB, FodB, FNZ Bank und MorgenFund.
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems={"center"}>
              <Grid item xs={12} md className={'processDescription'}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CustomerSelectionForOnboarding />
                  </Grid>
                  <Grid item xs={12} className={classes.flowDescription}>
                    Springen Sie nach der Kundenprofilierung mit den Kundendaten in den Portfolio Builder ab und erstellen
                    Sie ein individuelles Portfolio.
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={'auto'}>
                <img src={PtfBuilderOnboardingImg} alt={'Portfolio Builder Onboaring'}/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems={"center"}>
              <Grid item xs={12} md className={'processDescription'}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CustomerDepotSelectionModal setLoading={setLoading} />
                  </Grid>
                  <Grid item xs={12} className={classes.flowDescription}>
                    Überprüfen Sie bestehende Kundendepots mit dem Portfolio Builder - in regelmäßigen Abständen und im
                    Fall von Ein- bzw. Auszahlungen.
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={'auto'}>
                <img src={PtfBuilderTradingImg} alt={'Portfolio Builder Trading'}/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems={"center"}>
              <Grid item xs={12} md className={'processDescription'}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <MusterDepotSelectionModal />
                  </Grid>
                  <Grid item xs={12} className={classes.flowDescription}>
                    Analysieren Sie ein Musterdepot mit dem Portfolio Builder. Zum Beispiel, um ein Fremddepot zu
                    überprüfen.
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={'auto'}>
                <img src={PtfBuilderMPImg} alt={'Portfolio Builder Musterdepot'}/>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Grid container>
        <Grid item xs={12} sm className={classes.whiteContainer}>
          <Grid container spacing={4}>
            <Grid item xs={12} className={classes.subTitle}>Alles Wichtige rund um den Portfolio Builder</Grid>
            <Grid item xs={12} container spacing={2} style={{textAlign: 'center'}}>
              <Grid item xs={12}>
                <PbButton text={'Portfolio Builder Academy'} icon={ArrowIcon} onClick={() => openInNewTab('https://rise.articulate.com/share/laVgPv_AMJlMgnudkg6XyeKZztuh2iJa#/')} />
              </Grid>
              <Grid item xs={12}>
                <PbButton text={'Investment Einmaleins'} icon={ArrowIcon} onClick={() => openInNewTab('https://rise.articulate.com/share/mCg7gWbxDv9YVygtdARlwofONEsPsxAy#/')} />
              </Grid>
              <Grid item xs={12}>
                <PbButton text={'Häufig gestellte Fragen'} icon={ArrowIcon} onClick={() => openInNewTab('https://bca-cms-assets-prod-280976113942.s3.eu-central-1.amazonaws.com/Portfolio_Builder_FA_Qs_abb9ee3fff.pdf')} />
              </Grid>
              <Grid item xs={12}>
                <PbButton text={'Zum Webinar'} icon={ArrowIcon} onClick={() => openInNewTab('https://www.gotostage.com/channel/2a15eb35c29f4e34a040b3f76fa3347f/recording/4d087ed52eed415aa52af5a5c147fa89/watch?source=CHANNEL')} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm className={classes.whiteContainer}>
          <Grid container spacing={2} style={{textAlign: "center"}}>
            <Grid item xs={12}><img src={PtfBuilderContactsImg} alt="Contacts" className={classes.contactsImage}/></Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}><b>Sie haben Fragen zum Portfolio Builder?</b></Grid>
                <Grid item xs={12}>Schreiben Sie uns oder rufen Sie uns an. Wir helfen Ihnen gerne weiter</Grid>
                <Grid item xs={12}>
                  <PrimaryButton
                    text={'06171 – 9150 140'}
                    icon={<i className="far fa-phone"/>}
                    variant={'text'}
                    onButtonClick={() => openInNewTab('tel: 06171 – 9150 140')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <PrimaryButton
                    text={'Partnermanagement@bca.de'}
                    icon={<i className="far fa-envelope"/>}
                    variant={'text'}
                    onButtonClick={() => openInNewTab('mailto: Partnermanagement@bca.de')}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
};

export default withStyles(styles)(PortfolioBuilderPage);